// extracted by mini-css-extract-plugin
module.exports = {"colorAccent":"#e43f5a","colorAccentInvert":"#fff"};